import { ROLE_LABELS } from "common/activeTypeGate";

const COPY = {
  "job.apply": ["채용 공고는 강사·무용수 유형에서 이용할 수 있어요", "공고에 지원하려면 회원유형을 전환해 주세요."],
  "job.create": ["채용 공고는 학원 원장·공연팀 유형에서 등록할 수 있어요", "공고를 등록하려면 회원유형을 전환해 주세요."],
  "sub.apply": ["대타 공고는 강사·무용수 유형에서 이용할 수 있어요", "공고를 확인하거나 지원하려면 회원유형을 전환해 주세요."],
  "sub.create": ["대타 공고는 전문회원 유형에서 등록할 수 있어요", "공고를 등록하려면 회원유형을 전환해 주세요."],
  "casting.apply": ["캐스팅 공고는 무용수 유형에서 이용할 수 있어요", "공고에 지원하려면 무용수 유형으로 전환해 주세요."],
  "casting.create": ["캐스팅 공고는 공연팀·기획자 유형에서 등록할 수 있어요", "공고를 등록하려면 회원유형을 전환해 주세요."],
  "resume.read": ["강사 이력서는 학원 원장·공연팀 유형에서 확인할 수 있어요", "이력서를 확인하려면 회원유형을 전환해 주세요."],
  "resume.write": ["이력서는 강사·무용수 유형에서 등록할 수 있어요", "이력서를 등록하려면 회원유형을 전환해 주세요."],
  "dancer.read": ["무용수 이력서는 전문회원 유형에서 확인할 수 있어요", "이력서를 확인하려면 회원유형을 전환해 주세요."],
  "lesson.create": ["레슨은 강사·학원 원장 유형에서 등록할 수 있어요", "레슨을 등록하려면 회원유형을 전환해 주세요."],
  "space.create": ["공간은 공간보유자 유형에서 등록할 수 있어요", "공간을 등록하려면 회원유형을 전환해 주세요."],
};

const actionFromUrl = (url = "") => {
  if (/\/subs\//.test(url)) return url.includes("apply") ? "sub.apply" : "sub.create";
  if (/\/casting\//.test(url)) return url.includes("apply") ? "casting.apply" : "casting.create";
  if (/\/jobs\//.test(url)) return url.includes("apply") ? "job.apply" : "job.create";
  if (/lesson-products|\/lessons/.test(url)) return "lesson.create";
  return null;
};

export const roleGateCopy = ({ action, url, activeType, suggested, message } = {}) => {
  const resolvedAction = action || actionFromUrl(url);
  let copy = COPY[resolvedAction];
  if (!copy && /chat|rooms/i.test(url || "")) {
    copy = suggested === "ACADEMY"
      ? ["지원자 채팅은 학원 원장 유형에서 이용할 수 있어요", "지원자와 채팅하려면 학원 원장 유형으로 전환해 주세요."]
      : ["강사와의 채팅은 일반회원 유형에서 이용할 수 있어요", "다른 강사에게 채팅하려면 일반회원 유형으로 전환해 주세요."];
  }
  if (!copy && /quote|survey/i.test(url || "")) {
    copy = ["견적 기능은 알맞은 회원유형에서 이용할 수 있어요", "견적을 계속하려면 회원유형을 전환해 주세요."];
  }
  const active = ROLE_LABELS[activeType] || activeType || "현재";
  const title = copy?.[0] || message || "다른 회원유형에서 이용할 수 있어요";
  const cleanTitle = title
    .replace(/^\s*현재[^\n.!?。！？]*(?:유형|회원)[^\n.!?。！？]*(?:[.!?。！？]|\n)\s*/, "")
    .trim();
  return {
    title: cleanTitle || "다른 회원유형에서 이용할 수 있어요",
    description: `현재 ${active} 유형으로 이용 중이에요.\n${copy?.[1] || "회원유형을 전환한 후 다시 이용해 주세요."}`,
  };
};
